import Vue from 'vue'
import { Event } from '@/types'

/**
 * get string of assignees for event
 */
Vue.filter('getAssigneeString', (value: Event): string => {
  return value.assignees.map(v => v.name.split(' ')[0]).join(', ')
})
